import { Link } from "react-router";
import { PolicyType } from "../../Enums/PolicyType";
import { toPublicPath } from "../../Utils/publicRoutes";

export const POLICY_LINKS: { type: PolicyType; path: string; label: string }[] = [
  {
    type: PolicyType.Policies,
    path: "/politicas",
    label: "Políticas do Site"
  },
  {
    type: PolicyType.PrivacyPolicies,
    path: "/politica-privacidade",
    label: "Políticas de Privacidade"
  },
  {
    type: PolicyType.ExchangePolicies,
    path: "/politica-trocas",
    label: "Políticas de Trocas e Devoluções"
  },
  {
    type: PolicyType.CookiesPolicies,
    path: "/politica-cookies",
    label: "Políticas de Cookies"
  },
  {
    type: PolicyType.Faq,
    path: "/faq",
    label: "Perguntas Frequentes"
  }
];

type PoliciesLinksProps = {
  excludedPolicy: PolicyType;
  isMobile?: boolean;
};

const PoliciesLinks = ({ excludedPolicy, isMobile }: PoliciesLinksProps) => {
  const policyLinks = [
    { type: PolicyType.Policies, path: toPublicPath("/politicas"), label: "Políticas do Site" },
    { type: PolicyType.PrivacyPolicies, path: toPublicPath("/politica-privacidade"), label: "Políticas de Privacidade" },
    { type: PolicyType.ExchangePolicies, path: toPublicPath("/politica-trocas"), label: "Políticas de Trocas e Devoluções" },
    { type: PolicyType.CookiesPolicies, path: toPublicPath("/politica-cookies"), label: "Políticas de Cookies" },
    { type: PolicyType.Faq, path: toPublicPath("/faq"), label: "FAQ" }
  ];

  const containerClass = isMobile
    ? "grid grid-cols-2 sm:grid-cols-4 auto-rows-fr gap-2 w-full"
    : "bg-gray-50 flex flex-col gap-2";

  return (
    <div className={containerClass}>
      {policyLinks
        .filter(link => link.type !== excludedPolicy)
        .map(link => (
          <Link
            key={link.type}
            to={link.path}
            className={isMobile
              ? "flex items-center justify-center bg-white p-2 md:p-3 text-primary-600 text-xs sm:text-sm font-bold rounded-md text-center"
              : "bg-white p-3 md:p-4 text-primary-600 text-sm font-bold rounded-md"}
          >
            {link.label}
          </Link>
        ))}
    </div>
  );
};

export default PoliciesLinks;
